import { createCrudActions } from '../utils/crudGenerator';

const formatClients = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchClients,
    create: createClient,
    update: updateClient,
    delete: deleteClients
} = createCrudActions('CLIENT', "Cliente", formatClients);